import { useEffect, useRef, useState } from "react";

/* Gentle scroll-in reveal: opacity + small translate, triggered once by IntersectionObserver a little
   before the element enters the viewport. Pure CSS transition — keeps the first bundle animation-library free. */
export const Reveal = ({ children, delay = 0, className = "", y = 18 }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      /* Huge top margin: anything already scrolled past (e.g. after a fast jump) counts as seen too. */
      { rootMargin: "10000px 0px -40px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal ${shown ? "reveal-in" : ""} ${className}`}
      style={{ "--reveal-y": `${y}px`, transitionDelay: `${Math.min(delay, 0.25)}s` }}
    >
      {children}
    </div>
  );
};
